import React, { Fragment, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { multilanguage } from "redux-multilanguage";
import { useIsHomePage } from "../../utils/location";
import { deriveAppBase, setCurrentAppBase } from "../../utils/appBase";
import { fetchSite } from "../../redux/actions/siteActions";
import { fetchRootPage } from "../../redux/actions/rootPageActions";
import { fetchBrand } from "../../redux/actions/brandActions";
import { fetchDynamicPages } from "../../redux/actions/dynamicPagesActions";
import Header from "../../components/magnolia/header/Header";
import Footer from "../../components/magnolia/footer/Footer";

// For all pages (Magnolia and Static) but Homepage, Footer area is rendered here and takes the content from the store
// Footer area is also conditionally rendered for Homepage in Standard page template to make it editable

// This is also where the CURRENT SITE is established. The app serves multiple storefronts
// (every /shops/<name> tree plus the legacy APP_BASE), and everything site-scoped — root
// page (navigation, footer, brand), site info (locales), dynamic product page paths — hangs
// off the base derived from the URL. The fetches used to run once at store creation against
// the fixed APP_BASE; running them here, re-triggered when the derived base changes, is what
// makes a shop created in the Pages app work without any frontend change.
const BaseLayout = ({ children, currentLanguageCode }) => {
    const rootPage = useSelector((state) => state.rootPageData);
    const isHomePage = useIsHomePage();
    const location = useLocation();
    const dispatch = useDispatch();

    const appBase = deriveAppBase(location.pathname, currentLanguageCode);

    useEffect(() => {
        setCurrentAppBase(appBase);
        dispatch(fetchSite(appBase));
        // fetchBrand reads the root page's brand property from the store, so it must run
        // after the root page arrived, not in parallel.
        dispatch(fetchRootPage(appBase)).then(() => dispatch(fetchBrand()));
        dispatch(fetchDynamicPages(appBase));
    }, [appBase, dispatch]);

    return (
        <Fragment>
            {rootPage.navigation && <Header navigationId={rootPage.navigation} />}
            {children}
            {!isHomePage && rootPage.footer && <Footer content={rootPage.footer} />}
        </Fragment>
    );
};

export default multilanguage(BaseLayout);
